export default __webpack_public_path__ + "static/media/header-image.4ad912f9.jpg";